import { usePathname } from 'next/navigation'

export interface PageContext {
  sessionId?: string
  orgCode?: string
  userId?: string
}

/**
 * Derives what the current URL refers to so the Dev Toolkit can show the
 * right context-specific actions. Single source of truth so we don't sprinkle
 * pathname parsing across the toolkit.
 *
 * Recognized routes:
 *   /review/[id] · /review/[id]/share        → sessionId
 *   /organizations/[code]/...                → orgCode
 *   /admin/users/[id]                        → userId
 *   /admin/organizations/[code]              → orgCode
 *   /admin/sessions/[id]                     → sessionId
 */
export function usePageContext(): PageContext {
  const pathname = usePathname() ?? ''
  const segments = pathname.split('/').filter(Boolean)

  if (segments[0] === 'review' && segments[1]) {
    return { sessionId: segments[1] }
  }
  if (segments[0] === 'organizations' && segments[1]) {
    return { orgCode: segments[1] }
  }
  if (segments[0] === 'admin' && segments[1] && segments[2]) {
    if (segments[1] === 'users') return { userId: segments[2] }
    if (segments[1] === 'organizations') return { orgCode: segments[2] }
    if (segments[1] === 'sessions') return { sessionId: segments[2] }
  }
  return {}
}
